module.exports = __webpack_public_path__ + "img/for_road.3aebaefa.png";